import useLocalStorage from '../../../hooks/useLocalStorage';
import { features } from './features';

export interface EapConfig {
    hash?: string;
}

export const useEapState = () => {
    const [config, setConfig] = useLocalStorage<EapConfig>('eap-config', {});

    const featuresHashed = features.map(feature => simpleHash(feature.id).toString());
    const hash = featuresHashed.sort((a, b) => a.localeCompare(b)).join(',');

    const markVisited = () => {
        setConfig({
            hash,
        });
    };

    const oldFeatureHashes = (config.hash || '').split(',');
    const hasNew = config.hash !== hash && featuresHashed.some(h => !oldFeatureHashes.includes(h));

    return [hasNew, markVisited] as const;
};

function simpleHash(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0;
    }
    return hash >>> 0;
}
